import { environment } from '../environments/environment';
import type { MetricService } from './core/services/metric.service';

let metricServiceRef: MetricService | undefined;

/** Binds deprecated {@link GTrack} to the root MetricService (called from MetricService constructor). */
export function bindGTrackToMetricService(service: MetricService): void {
  metricServiceRef = service;
}

/**
 * @deprecated Use `MetricService.track({ name })` instead. Forwards to backend + GA (event name only).
 */
export const GTrack = (name: string, _page: string, _params: Record<string, unknown> = {}) => {
  metricServiceRef?.track({ name });
};

export const clog = (...args: unknown[]) => {
  if (environment.production) {
    return;
  }

  console.log(args);
};
